import {getApps,initializeApp} from "firebase/app";

const config={
 apiKey:process.env.REACT_APP_FIREBASE_API_KEY,
 authDomain:process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
 projectId:process.env.REACT_APP_FIREBASE_PROJECT_ID,
 storageBucket:process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
 messagingSenderId:process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
 appId:process.env.REACT_APP_FIREBASE_APP_ID,
 measurementId:process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
const configured=Boolean(config.apiKey&&config.projectId&&config.appId&&config.measurementId);
const enabled=process.env.REACT_APP_FIREBASE_ANALYTICS_ENABLED==="true";
let analyticsPromise;

function consentAllowsAnalytics(){
 if(typeof window==="undefined")return false;
 return window.localStorage.getItem("dirnation_analytics_consent")!=="denied";
}
async function analyticsInstance(){
 if(!configured||!enabled||!consentAllowsAnalytics()||typeof window==="undefined")return null;
 if(!analyticsPromise)analyticsPromise=(async()=>{try{const {getAnalytics,initializeAnalytics,isSupported}=await import("firebase/analytics");if(!(await isSupported()))return null;const app=getApps()[0]||initializeApp(config);try{return initializeAnalytics(app,{config:{send_page_view:false}})}catch{return getAnalytics(app)}}catch{return null}})();
 return analyticsPromise;
}
function safeParams(params={}){return Object.fromEntries(Object.entries(params).filter(([,v])=>v!==undefined&&v!==null&&v!=="").map(([k,v])=>[k,typeof v==="string"?v.slice(0,100):v]))}
export async function trackEvent(name,params={}){try{const analytics=await analyticsInstance();if(!analytics)return false;const {logEvent}=await import("firebase/analytics");logEvent(analytics,name,safeParams(params));return true}catch{return false}}
export function trackPageView(path,title=document.title){if(path.startsWith("/admin"))return Promise.resolve(false);return trackEvent("page_view",{page_path:path,page_title:title,page_location:window.location.href})}
export function setAnalyticsConsent(granted){if(typeof window!=="undefined")window.localStorage.setItem("dirnation_analytics_consent",granted?"granted":"denied");if(!granted)analyticsPromise=undefined}
export const firebaseAnalyticsStatus={configured,enabled};
